// extracted by mini-css-extract-plugin
module.exports = {"overlay":"style_overlay__AJVTd","img":"style_img__389Qs","active":"style_active__2X4pD"};